import { AI_FEATURE_HELP_CONTENT } from './aiFeatureHelp';

/**
 * Centralized configuration for all AI features organized by categories
 * Each feature includes all data needed for both display and help modal
 */
export const AI_FEATURE_CATEGORIES = [
  {
    id: 'background',
    title: '🖼️ Sfondo',
    features: [
      {
        id: 'removebg',
        title: 'Rimuovi sfondo',
        image: '/assets/sidebar/ai/rimuovi_sfondo.png',
        prompt: 'REMOVE_BACKGROUND',
        caption: 'Rimuovi sfondo',
        ...AI_FEATURE_HELP_CONTENT['removebg'],
      },
      {
        id: 'blurbg',
        title: 'Sfoca sfondo',
        image: '/assets/sidebar/ai/sfoca_sfondo.png',
        prompt: 'BLUR_BACKGROUND',
        caption: 'Sfoca sfondo',
        ...AI_FEATURE_HELP_CONTENT['blurbg'],
      },
      {
        id: 'dissolvenza',
        title: 'Dissolvenza',
        image: '/assets/sidebar/ai/dissolvenza.png',
        prompt: 'DISSOLVENZA',
        caption: 'Dissolvenza',
        loadingMessages: [
          { icon: '🖼️', text: 'Analizzando la foto...' },
          { icon: '⭕', text: 'Creando la forma ovale...' },
          { icon: '🌫️', text: 'Applicando la dissolvenza graduale...' },
          { icon: '✨', text: 'Sfumando verso il bianco...' },
          { icon: '🎨', text: 'Perfezionando i bordi morbidi...' },
          { icon: '💎', text: 'Controllo qualità finale...' },
        ],
        ...AI_FEATURE_HELP_CONTENT['dissolvenza'],
      },
      {
        id: 'expand',
        title: 'Espandi Scena',
        image: '/assets/sidebar/ai/espandi_scena.png',
        prompt: 'EXPAND_IMAGE',
        caption: 'Espandi Scena',
        ...AI_FEATURE_HELP_CONTENT['expand'],
      },
    ],
  },
  {
    id: 'quality',
    title: '✨ Qualità e Restauro',
    features: [
      {
        id: 'imageEnhancement',
        title: 'Migliora risoluzione',
        image: '/assets/sidebar/ai/migliora_risoluzione.png',
        prompt: 'ENHANCE_IMAGE',
        caption: 'Migliora risoluzione',
        ...AI_FEATURE_HELP_CONTENT['imageEnhancement'],
      },
      {
        id: 'colorizebw',
        title: 'Colora Foto Bianco e Nero',
        image: '/assets/sidebar/ai/colora.png',
        prompt: 'COLORIZE_BW',
        caption: 'Colora Foto Bianco e Nero',
        ...AI_FEATURE_HELP_CONTENT['colorizebw'],
      },
      {
        id: 'restore-photo',
        title: 'Restaura Foto',
        image: '/assets/sidebar/ai/restaura_foto.png',
        prompt: 'RESTORE_PHOTO',
        caption: 'Restaura Foto',
        loadingMessages: [
          { icon: '📷', text: 'Analizzando la foto danneggiata...' },
          { icon: '🔍', text: 'Identificando i difetti...' },
          { icon: '🔧', text: 'Riparando graffi e macchie...' },
          { icon: '🎨', text: 'Recuperando i colori originali...' },
          { icon: '✨', text: 'Migliorando la nitidezza...' },
          { icon: '💎', text: 'Controllo qualità finale...' },
        ],
        ...AI_FEATURE_HELP_CONTENT['restore-photo'],
      },
      {
        id: 'remove-document-photo-marks',
        title: 'Ripulisci Foto Documento',
        image: '/assets/sidebar/ai/ripulisci_foto_documento.png',
        prompt: 'RESTORE_ID_PHOTO',
        caption: 'Ripulisci Foto Documento',
        loadingMessages: [
          { icon: '🪪', text: 'Analizzando la fototessera...' },
          { icon: '🔍', text: 'Identificando timbri e segni...' },
          { icon: '🧹', text: 'Rimuovendo le marcature...' },
          { icon: '🖼️', text: 'Ripulendo lo sfondo...' },
          { icon: '✨', text: 'Migliorando la qualità...' },
          { icon: '💎', text: 'Controllo qualità finale...' },
        ],
        ...AI_FEATURE_HELP_CONTENT['remove-document-photo-marks'],
      },
      {
        id: 'change-clothes',
        title: 'Cambia abito',
        image: '/assets/sidebar/ai/cambio_abito.png',
        prompt: 'CHANGE_CLOTHES',
        caption: 'Cambia abito',
        ...AI_FEATURE_HELP_CONTENT['change-clothes'],
      },
    ],
  },
  {
    id: 'corrections',
    title: '🪄 Correzioni e Rimozioni',
    features: [
      {
        id: 'magic-eraser',
        title: 'Pennello correttivo',
        image: '/assets/sidebar/ai/pennello_correttivo.png',
        prompt: 'MAGIC_ERASER',
        caption: 'Pennello correttivo',
        ...AI_FEATURE_HELP_CONTENT['magic-eraser'],
      },
      {
        id: 'remove-hug',
        title: 'Rimuovi Abbraccio',
        image: '/assets/sidebar/ai/togli_abbraccio.png',
        prompt: 'REMOVE_HUG',
        caption: 'Rimuovi Abbraccio',
        loadingMessages: [
          { icon: '🤗', text: 'Analizzando la foto...' },
          { icon: '👥', text: "Identificando l'abbraccio..." },
          { icon: '✂️', text: 'Separando le persone...' },
          { icon: '🎨', text: 'Ricostruendo lo sfondo...' },
          { icon: '✨', text: 'Rifinitura dei dettagli...' },
          { icon: '💎', text: 'Controllo qualità finale...' },
        ],
        ...AI_FEATURE_HELP_CONTENT['remove-hug'],
      },
      {
        id: 'remove-glasses',
        title: 'Rimuovi Occhiali',
        image: '/assets/sidebar/ai/rimuovi_occhiali.png',
        prompt: 'REMOVE_GLASSES',
        caption: 'Rimuovi Occhiali',
        loadingMessages: [
          { icon: '👓', text: 'Analizzando la foto...' },
          { icon: '🔍', text: 'Identificando gli occhiali...' },
          { icon: '✂️', text: 'Rimuovendo la montatura...' },
          { icon: '👁️', text: 'Ricostruendo il viso...' },
          { icon: '✨', text: 'Perfezionando i dettagli...' },
          { icon: '💎', text: 'Controllo qualità finale...' },
        ],
        ...AI_FEATURE_HELP_CONTENT['remove-glasses'],
      },
      {
        id: 'remove-glasses-glare',
        title: 'Rimuovi Riflesso dagli Occhiali',
        image: '/assets/sidebar/ai/rimuovi_riflesso_occhiali.png',
        prompt: 'REMOVE_GLASSES_GLARE',
        caption: 'Rimuovi Riflesso dagli Occhiali',
        loadingMessages: [
          { icon: '👓', text: 'Analizzando gli occhiali...' },
          { icon: '✨', text: 'Identificando i riflessi...' },
          { icon: '🔧', text: 'Rimuovendo i bagliori...' },
          { icon: '👁️', text: 'Recuperando i dettagli...' },
          { icon: '🎨', text: 'Migliorando la trasparenza...' },
          { icon: '💎', text: 'Controllo qualità finale...' },
        ],
        ...AI_FEATURE_HELP_CONTENT['remove-glasses-glare'],
      },
      {
        id: 'remove-the-person-in-front-of-the-subject',
        title: 'Rimuovi la persona davanti al soggetto',
        image: '/assets/sidebar/ai/rimuovi_persona_davanti.png',
        prompt: 'REMOVE_PERSON_IN_FRONT_OF_SUBJECT',
        caption: 'Rimuovi la persona davanti al soggetto',
        loadingMessages: [
          { icon: '👥', text: 'Analizzando le persone nella foto...' },
          { icon: '🎯', text: 'Identificando il soggetto principale...' },
          { icon: '✂️', text: 'Rimuovendo la persona in primo piano...' },
          { icon: '🎨', text: 'Ricostruendo le parti nascoste...' },
          { icon: '✨', text: 'Perfezionando i dettagli...' },
          { icon: '💎', text: 'Controllo qualità finale...' },
        ],
        ...AI_FEATURE_HELP_CONTENT['remove-the-person-in-front-of-the-subject'],
      },
    ],
  },
  {
    id: 'face',
    title: '💄 Viso e Bellezza',
    features: [
      {
        id: 'smile',
        title: 'Sorriso',
        image: '/assets/sidebar/ai/sorriso.png',
        prompt: 'ADD_SMILE',
        caption: 'Sorriso',
        ...AI_FEATURE_HELP_CONTENT['smile'],
      },
      {
        id: 'makeLookYounger',
        title: 'Filtro bellezza',
        image: '/assets/sidebar/ai/filtro_bellezza.png',
        prompt: 'MAKE_LOOK_YOUNGER',
        caption: 'Filtro bellezza',
        ...AI_FEATURE_HELP_CONTENT['makeLookYounger'],
      },
      {
        id: 'faceEnhancement',
        title: 'Migliora viso',
        image: '/assets/sidebar/ai/migliora_risoluzione.png',
        prompt: 'ENHANCE_FACE',
        caption: 'Migliora viso',
        ...AI_FEATURE_HELP_CONTENT['faceEnhancement'],
      },
    ],
  },
];

/**
 * Default loading messages for AI features
 */
export const DEFAULT_AI_LOADING_MESSAGES = [
  { icon: '🔍', text: 'Analizzando la foto...' },
  { icon: '🤖', text: 'Elaborando con intelligenza artificiale...' },
  { icon: '🎨', text: 'Applicando le modifiche richieste...' },
  { icon: '✨', text: 'Ottimizzando i risultati...' },
  { icon: '🎯', text: 'Perfezionando i dettagli...' },
  { icon: '💎', text: 'Controllo qualità finale...' },
];

/**
 * Get all features as a flat array (for backward compatibility)
 */
export function getAllFeatures() {
  return AI_FEATURE_CATEGORIES.reduce((acc, category) => {
    return acc.concat(category.features);
  }, []);
}

/**
 * Get a specific feature by ID
 */
export function getFeatureById(featureId) {
  for (const category of AI_FEATURE_CATEGORIES) {
    const feature = category.features.find((f) => f.id === featureId);
    if (feature) return feature;
  }
  return null;
}

/**
 * Get a specific category by ID
 */
export function getCategoryById(categoryId) {
  return AI_FEATURE_CATEGORIES.find((cat) => cat.id === categoryId);
}

/**
 * Get feature count for a category
 */
export function getCategoryFeatureCount(categoryId) {
  const category = getCategoryById(categoryId);
  return category ? category.features.length : 0;
}
